import { BerechnetesMonatssoll } from '@/domain/mitarbeiter/features/anlageassistent/content/Bezahlung/Sollstunden/BerechnetesMonatssoll';
import { TageSelect } from '@/domain/mitarbeiter/features/anlageassistent/content/Bezahlung/Sollstunden/TageSelect';
import { Tagessoll } from '@/domain/mitarbeiter/features/anlageassistent/content/Bezahlung/Sollstunden/Tagessoll';
import { useAnlageassistentFormContext } from '@/domain/mitarbeiter/features/anlageassistent/context/AnlageassistentFormContext';
import { Body, Title, Separator } from '@e2n/ui/v2';
import { useTranslation } from 'react-i18next';

// oxlint-disable-next-line max-lines-per-function
export function Richtwert() {
  const { t } = useTranslation();
  const form = useAnlageassistentFormContext();
  return (
    <form.Subscribe
      selector={(state) => ({
        richtwertEinheit:
          state.values.bezahlung.arbeitszeitkonto.stundenloehner
            .richtwertEinheit,
      })}>
      {({ richtwertEinheit }) => (
        <>
          {richtwertEinheit === 'euro' && (
            <div className="flex flex-col gap-6">
              <div className="flex flex-col gap-3">
                <Title>
                  {t(
                    'domain.mitarbeiter.create.steps.bezahlung.sollstunden.form.richtwertEuro.title',
                  )}
                </Title>
                <Body>
                  {t(
                    'domain.mitarbeiter.create.steps.bezahlung.sollstunden.form.richtwertEuro.description',
                  )}
                </Body>
              </div>
              <div className="grid lg:grid-cols-2">
                <form.AppField name="bezahlung.arbeitszeitkonto.stundenloehner.richtwertEuro">
                  {(field) => (
                    <field.MoneyInput
                      label={t(
                        'domain.mitarbeiter.create.steps.bezahlung.sollstunden.form.richtwertEuro.label',
                      )}
                      isRequired
                    />
                  )}
                </form.AppField>
              </div>
            </div>
          )}
          {richtwertEinheit === 'stunden' && (
            <div className="flex flex-col gap-6">
              <div className="flex flex-col gap-3">
                <Title>
                  {t(
                    'domain.mitarbeiter.create.steps.bezahlung.sollstunden.form.richtwertStunden.title',
                  )}
                </Title>
                <Body>
                  {t(
                    'domain.mitarbeiter.create.steps.bezahlung.sollstunden.form.richtwertStunden.description',
                  )}
                </Body>
              </div>
              <div className="grid lg:grid-cols-2">
                <form.AppField name="bezahlung.arbeitszeitkonto.stundenloehner.richtwertStunden">
                  {(field) => (
                    <field.HoursInput
                      label={t(
                        'domain.mitarbeiter.create.steps.bezahlung.sollstunden.form.richtwertStunden.label',
                      )}
                      placeholder="hh:mm"
                      isRequired
                      suffix={t(
                        'domain.mitarbeiter.create.steps.bezahlung.sollstunden.form.richtwertStunden.suffix',
                      )}
                    />
                  )}
                </form.AppField>
              </div>
            </div>
          )}
          {richtwertEinheit === 'exakt' && (
            <div className="flex flex-col gap-6 pb-10">
              <TageSelect />
              <Tagessoll />
              <Separator className="my-2" />
              <BerechnetesMonatssoll />
            </div>
          )}
        </>
      )}
    </form.Subscribe>
  );
}
